import type { IconType } from "@circle-react-shared/Icon";
import { Icon } from "@circle-react-shared/Icon";
import { IconButton } from "./IconButton";

export interface ContentProps {
  icon: IconType;
  item: any;
  onClick: (event: any) => void;
}

export const Content = ({ item, icon, onClick }: ContentProps) => {
  const onClickHandler = () => {
    onClick({ item });
  };

  const onPointerDownHandler = (
    event: React.PointerEvent<HTMLButtonElement>,
  ) => {
    event.stopPropagation();
  };

  return (
    <IconButton
      className="invisible flex group-hover:visible"
      onClick={onClickHandler}
      onPointerDown={onPointerDownHandler}
    >
      <Icon type={icon} size={16} useWithFillCurrentColor />
    </IconButton>
  );
};
